var _path, _path2, _g, _g2, _path3, _path4, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 85,
    viewBox: "0 0 106 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5786 36.2076C16.6958 41.1713 17.9691 47.3322 22.8447 53.5136C32.5958 65.8763 53.0635 73.6397 68.5606 70.8536C76.3092 69.4605 81.348 65.6938 83.2307 60.73L85.9282 53.6183C87.8109 48.6545 86.5377 42.4937 81.6621 36.3123C71.911 23.9495 51.4432 16.1861 35.9461 18.9723C28.1976 20.3654 23.1588 24.132 21.2761 29.0958L18.5786 36.2076Z",
    fill: "url(#paint0_linear_2920_5953)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2920_5953",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 18,
    width: 70,
    height: 54
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5786 36.2076C16.6958 41.1713 17.9691 47.3322 22.8447 53.5136C32.5958 65.8763 53.0635 73.6397 68.5606 70.8536C76.3092 69.4605 81.348 65.6938 83.2307 60.73L85.9282 53.6183C87.8109 48.6545 86.5377 42.4937 81.6621 36.3123C71.911 23.9495 51.4432 16.1861 35.9461 18.9723C28.1976 20.3654 23.1588 24.132 21.2761 29.0958L18.5786 36.2076Z",
    fill: "url(#paint1_linear_2920_5953)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2920_5953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9695 41.7673L60.1325 47.8979L42.4202 55.6006L38.0062 67.238L23.8049 55.9352L28.219 44.2978L43.9695 41.7673Z",
    fill: "#ED9A15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3802 47.2514L47.4497 42.3469L56.2448 60.1038L51.8308 71.7411L64.8169 72.5993L69.4761 60.3154L60.3802 47.2514Z",
    fill: "#FFD454"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2920_5953)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.3912,
    cy: 18.3912,
    r: 18.3912,
    transform: "matrix(0.987062 -0.160338 0.632437 0.774612 23.918 29.7959)",
    fill: "#FFA81E"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1009 36.6014C88.0362 47.5455 83.9746 58.2537 70.029 60.519C56.0834 62.7844 37.5347 55.7489 28.5994 44.8049C19.6641 33.8608 23.7258 23.1526 37.6714 20.8872C51.6169 18.6219 70.1656 25.6574 79.1009 36.6014Z",
    stroke: "url(#paint2_linear_2920_5953)",
    strokeWidth: 1.38293
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.992 37.7559C78.4122 45.6194 75.4939 53.3135 65.4736 54.9412C55.4534 56.5689 42.1258 51.5137 35.7056 43.6502C29.2854 35.7867 32.2038 28.0926 42.224 26.4649C52.2442 24.8372 65.5718 29.8924 71.992 37.7559Z",
    stroke: "url(#paint3_linear_2920_5953)",
    strokeWidth: 1.38293
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_2920_5953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9862 51.7467L56.6036 51.592L51.9318 41.2105L46.3012 41.0117L44.7996 37.6748L60.4432 38.227L61.9449 41.5639L56.3143 41.3652L60.9862 51.7467ZM42.4637 32.484L58.1073 33.0362L59.609 36.3732L43.9653 35.8209L42.4637 32.484Z",
    fill: "#FFD454"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2920_5953",
    x: 32.1406,
    y: 26.5422,
    width: 43.125,
    height: 29.1018,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.0744
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.933333 0 0 0 0 0.573446 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2920_5953"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_2920_5953",
    x: 42.4648,
    y: 32.4841,
    width: 24.1523,
    height: 20.4986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.0372
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2920_5953"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2920_5953",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.691466
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2920_5953"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2920_5953",
    x1: 83.7763,
    y1: 23.5863,
    x2: 17.6758,
    y2: 61.3748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA413"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2920_5953",
    x1: 83.7763,
    y1: 23.5863,
    x2: 17.6758,
    y2: 61.3748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA413"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2920_5953",
    x1: 49.2198,
    y1: 12.2325,
    x2: 29.9685,
    y2: 57.1081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA413"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2920_5953",
    x1: 50.4875,
    y1: 20.0353,
    x2: 36.5124,
    y2: 52.6119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA413"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin3);
export default __webpack_public_path__ + "static/media/Coin3.45191ac22cf388aa9cc5f1ea8965e54f.svg";
export { ForwardRef as ReactComponent };